import styled, { css } from 'styled-components';
import { media } from 'styledComponents/utils';

export const SectionWrapper = styled.div`
background-color: white;
position: relative;
z-index: 5;
margin: 0 auto;
padding: 35px;
margin-top: -10px;
max-width: 375px;
width: 100%;
${props => props.submitted ? 'padding-bottom: 35px;' : 'padding-bottom: 0;'}
${media.tablet`
  padding: 40px 60px;
  padding-bottom: 0;
  max-width: 100%;  
  margin-top: 20px;
`}

${media.desktop`
  max-width: 800px;
  margin-right: 40px;
  margin-top: 40px;
  padding: 40px;
`}

input {
  z-index: 10;
  position: relative;
}

h5 {
  display: none;
  ${props => (props.activeSection !== props.section) && props.guest && 'display: block;'}
  position: absolute;
  top: 75px;
  right: 60px;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

input:focus ~ label, input:valid ~ label, input.filled ~ label {
  font-size: 0.675rem;
  top: -15px;
  left: 0;
  position: absolute;
  z-index: 5;
  transition: all .2s ease;
  color: $darkGrey;
}

.error{
  color: red;
  font-size: 11px;
}

.no-guest {
  ${props => props.guest && 'display: none;'}
}

.content{
  display: none;
  ${props => props.activeSection === props.section && 'display: block;'}
}

h1 {
  letter-spacing: 0;
  font-size: 22px;
  margin-top: 5px;
  margin-bottom: 10px;
  display: flex;
  ${media.desktop`
    font-size: 32px;
  `}
}
h2 {
  font-size: 14px;
  margin-top: 10px;
  ${media.tablet`
    font-size: 18px;
    margin-top: 15px;
  `}
}
.logout {
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  ${media.tablet`
    font-size: 14px;
    position: absolute;
    top: 85px;
    right: 60px;
  `}
  ${media.desktop`
    top: 95px;
  `}
}
hr {
  margin-bottom: 20px;
}
.first-child-target > div:first-child {
  div {
    border-top: none;
  }
}
`;

export const CheckWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 15px;
  ${media.tablet`
    margin-top: 25px;
  `}
  ${media.desktop`
    margin-bottom: 10px;
  `}
  input {
    visibility: hidden;
  }
  label {
    font-size: 10px;
    font-family: inherit;
    text-transform: none;
    position: relative;
    margin-left: 5px;
    margin-top: 13px;
    z-index: 5;

    color: #000000;
    ${media.tablet`

    `}
    ${media.desktop`
      font-size: 18px;
      margin-top: 0;
      margin-left: 10px;
    `}
  }
  input:focus ~ label, input:valid ~ label, input.filled ~ label {
    font-size: 10px;
    ${media.desktop`
      font-size: 18px;
      margin-top: 13px;
      margin-left: 10px;
    `}
    position: relative;
    color: #000000;
  }
`;

export const Checkbox = styled.div`
  width: 15px;
  height: 15px;
  min-width: 15px;
  border-radius: 2px;
  margin-left: -13px;
  cursor: pointer;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 3px;
  svg {
    height: 80%;
    width: 80%;
    margin-top: -10px;
  }
  ${props => props.checked ? css`
    background-color: #000000;
    svg {
      path {
        fill: white;
      }
    }
  ` : css`
    background-color: white;
    border: 1px solid #000000;
    svg {
      display: none;
    }
  `}
`;

export const Button = styled.div`
  background-color: #000000;
  color: white;
  padding: 18px 25px;
  width: fit-content;
  border-radius: 50px;
  font-size: 13px;
  margin: 0 auto;
  cursor: pointer;
  min-width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  ${media.desktop`
    margin-left: 0px;
    padding: 22px 25px;
  `}
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  ${media.desktop`
    margin-top: 30px;
  `}
  h4 {
    font-size: 18px;
    text-decoration: underline;
    cursor: pointer;
    margin: 0;
  }
`;

export const CircleCheckWrapper = styled.div`
  width: 30px;
  height: 30px;
  margin-left: 10px;
  ${media.desktop`
    margin-top: 5px;
  `}
  svg {
    width: 100%;
    height: 100%;
    path {
      fill: limegreen;
    }
  }
`;
